import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-market-insights',
  templateUrl: './market-insights.component.html',
  styleUrl: './market-insights.component.scss',
})
export class MarketInsightsComponent {
  @Input() searchTerm = '';
  selectedCategory = 'charts';

  clearSearch(): void {
    this.searchTerm = '';
  }

  onCategoryChange(category: string): void {
    this.selectedCategory = category;
    this.clearSearch();
  }
}
